import {Base} from "@/api/Base"

export class PlanListAll extends Base {
    path = "plan/listAll"
}